import classes from './SystemSuggestions.module.css'


function SystemSuggestions(props) {
    let options = props.options.map((o,i) => {
        return (<div key={i} className={classes.SystemSuggestions} onClick={() => o.handler()}>{o.text}</div>)
    })
    
    if (props.disabled) {
        options = props.options.map((o,i) => {
            return (<div key={i} className={classes.SystemSuggestionsDisabled} onClick={() => {}}>{o.text}</div>)
        })
    }
    return (
        <div className={classes.SystemSuggestionsContainer}>
            {options}
        </div>
    );
}

export default SystemSuggestions;